<script setup>
import MainLayout from 'layouts/MainLayout.vue';
import PageNotFoundErrorPage from 'pages/error-pages/PageNotFoundErrorPage.vue';
import UnknownErrorPage from 'pages/error-pages/UnknownErrorPage.vue';
import { useErrorStore } from 'stores/error-store';
import { computed } from 'vue';

/**
 * The screen each terminal status is answered with. A status that is missing here, such as the 403 a profile error
 * route carries, leaves the matched route rendering and only changes the status the response carries, which is how a
 * blocked, restricted or suspended profile keeps its own explanation rather than a generic error.
 *
 * The screens always sit in the site's own layout rather than the matched route's, so a not found page looks the same
 * whether the address named nothing or named a market, invite or profile that does not exist.
 */
const errorPages = Object.freeze({
    404: PageNotFoundErrorPage,
    500: UnknownErrorPage
});

const errorStore = useErrorStore();

const errorPageComponent = computed(() => {
    return errorPages[errorStore.statusCode] ?? null;
});
</script>

<template>
    <MainLayout v-if="errorPageComponent">
        <component :is="errorPageComponent"/>
    </MainLayout>
    <router-view v-else/>
</template>
